import {useDoctorList, useSendScan} from "hooks/useScan";
import React, {useEffect, useState} from "react";
import {fakeNfc} from 'components/scan/fakeNfc'
import Loading from "components/Loading/Loading";
import Grid from "@mui/material/Grid";
import celebration from 'assets/img/celebration.svg'
import styles from "assets/css/scanListModal.module.css";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const SendScanToDoctor = (props) => {
    const {isLoading,successfullySend,activeDoctorId,retryHandler,successHandler}=props
    const {data} = useDoctorList()
    const selectedDoctor = data?data.find((item, index) => index === activeDoctorId):{}

    return(
        <>
            {isLoading&&successfullySend===null&&
                <Loading style={{ margin: '150px auto 0',
                    display: 'flex',
                    justifyContent: 'center',
                    height: '90px', width: '90px'}}/>
            }
            {successfullySend&&!isLoading&&(
                <Grid container>
                    <p className={styles.successTitle}>ارسال اسکن موفق  برای پزشک</p>
                    <img className={styles.successImage} src={celebration}/>
                    <p className={styles.successText}>اسکن در لیست بیماران دکتر {selectedDoctor?.firstName}{' '}{selectedDoctor?.lastName}{' '}
                        قرار گرفت</p>
                    <Button onClick={successHandler} className={`${styles.confirmButton} `}>
                        متوجه شدم </Button>

                </Grid>
            )}
            {successfullySend===false&&!isLoading&&(
                <Grid container>
                    <p className={styles.errorTitle}>ارسال اسکن ناموفق  برای پزشک</p>
                    <ErrorOutlineIcon className={styles.iconError}/>

                    <p className={styles.errorText}> در ارسال  اختلال  ایجاد شده است!
                        <br/>لطفا دوباره تلاش کنید</p>
                    <Button onClick={()=>retryHandler(activeDoctorId)} className={`${styles.retryButton} `}>
                        ارسال دوباره برای پزشک</Button>

                </Grid>
            )}



</>
    )

}